import React, { Component } from 'react';
import Grid from '../../../../components/Grid'
import dataProvider, { Order as dataOrder } from '../../../../components/Grid/dataProvider';
import localProvider from '../../../../components/Grid/localProvider';
import { compareArrayLength } from '../../CroUtils';
import { noop, isUndefined } from 'lodash';

class CommonGrid extends Component {
  static defaultProps = {
    filtering: true,
    adding: false, deleting: false, hidding: false,
    onAdd: noop, onRemove: noop, onRowClick: noop,
    filters: [],
    sort: 'created',
    secondarySort: null,
    order: dataOrder.DESC,
  }

  shouldComponentUpdate(nextProps, nextState) {
    return nextProps.url !== this.props.url || compareArrayLength(nextProps.items, this.props.items) ||
        nextProps.query !== this.props.query || nextProps.ovmId !== this.props.ovmId;
  }

  render() {
    const { onAdd, onRemove, adding, editing, filtering, hidding, deleting, url, query, items, gridName, columns, filters, sort, secondarySort, order, canNotOpen, editText = '', pageSize = 1000, ...rest } = this.props;


    const props = {
      columns,
      filtering,
      hidding,
      onAdd,
      adding,
      editing: editing && editText !== '' ? true : false,
      addButtonStyle: { color: 'white', marginRight: 10, padding: '0px 15px' },
      deleting,
      onRemove,
      defaultFilters: filters,
      editText,
      gridName
    };

    const isLocal = isUndefined(url);
    const ConnectedGrid = isLocal ?
        localProvider(gridName, { items, sort, order, pageSize }, Grid) :
        dataProvider(gridName, { url, query, sort, secondarySort, order }, Grid);

    return (
        <ConnectedGrid rowStyle={canNotOpen ? { cursor: 'not-allowed' } : { cursor: 'pointer' }} showPaging={!isLocal} {...rest} {...props} />
    );
  }
}

export default CommonGrid;
